import React from 'react';
import { Link } from 'react-router-dom';
import './Privacy.css';

const Privacy = () => {
  return (
    <div className="privacy-page">
      <div className="container">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: December 28, 2025</p>
        <p className="last-updated">
          This policy covers svtconsulting.co and the SVTPortal app. Each of our other apps has its
          own privacy policy, linked from <Link to="/apps">svtconsulting.co/apps</Link>.
        </p>

        <section className="privacy-section">
          <h2>Introduction</h2>
          <p>
            SVT Consulting LLC ("SVT Consulting," "we," "us," or "our") is committed to protecting 
            your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard 
            your information when you visit our website svtconsulting.co, use our mobile application 
            SVTPortal, or engage our services.
          </p>
          <p>
            Please read this privacy policy carefully. If you do not agree with the terms of this 
            privacy policy, please do not access the site or use our applications.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Information We Collect</h2>
          
          <h3>Personal Information</h3>
          <p>We may collect personal information that you voluntarily provide to us when you:</p>
          <ul>
            <li>Register for an account on our mobile application</li>
            <li>Request a quote or consultation</li>
            <li>Contact us through our website or application</li>
            <li>Subscribe to our newsletter</li>
            <li>Use our services</li>
          </ul>
          
          <p>This information may include:</p>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Business name and address</li>
            <li>Login credentials</li>
          </ul>

          <h3>Automatically Collected Information</h3>
          <p>
            When you access our website or application, we may automatically collect certain 
            information about your device and usage, including:
          </p>
          <ul>
            <li>Device type and operating system</li>
            <li>IP address</li>
            <li>Browser type</li>
            <li>Usage patterns and preferences</li>
            <li>App crash reports and performance data</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide, maintain, and improve our services</li>
            <li>Process and manage service requests</li>
            <li>Communicate with you about appointments, updates, and promotions</li>
            <li>Send push notifications (with your consent)</li>
            <li>Respond to your inquiries and provide customer support</li>
            <li>Monitor and analyze usage trends</li>
            <li>Protect against fraudulent or unauthorized activity</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>Mobile Application</h2>
          <p>Our SVTPortal mobile application may request access to:</p>
          <ul>
            <li><strong>Camera:</strong> To capture photos for service call documentation</li>
            <li><strong>Photo Library:</strong> To upload existing photos for service documentation</li>
            <li><strong>Push Notifications:</strong> To send you updates about service calls and important alerts</li>
          </ul>
          <p>
            You can manage these permissions at any time through your device settings. 
            Denying certain permissions may limit app functionality.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Data Storage and Security</h2>
          <p>
            We implement appropriate technical and organizational security measures to protect 
            your personal information. Your data is stored on secure servers and transmitted 
            using industry-standard encryption (SSL/TLS).
          </p>
          <p>
            While we strive to protect your personal information, no method of transmission 
            over the Internet or electronic storage is 100% secure. We cannot guarantee 
            absolute security.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Information Sharing</h2>
          <p>We do not sell, trade, or rent your personal information to third parties. We may share your information with:</p>
          <ul>
            <li><strong>Service Providers:</strong> Third-party vendors who assist us in operating our business (e.g., cloud hosting, email services)</li>
            <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
            <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>Your Rights</h2>
          <p>Depending on your location, you may have the right to:</p>
          <ul>
            <li>Access the personal information we hold about you</li>
            <li>Request correction of inaccurate information</li>
            <li>Request deletion of your personal information</li>
            <li>Opt-out of marketing communications</li>
            <li>Withdraw consent where processing is based on consent</li>
          </ul>
          <p>To exercise these rights, please contact us using the information below.</p>
        </section>

        <section className="privacy-section">
          <h2>Children's Privacy</h2>
          <p>
            Our services are not intended for individuals under the age of 18. We do not 
            knowingly collect personal information from children. If you believe we have 
            collected information from a child, please contact us immediately.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any 
            changes by posting the new Privacy Policy on this page and updating the "Last Updated" 
            date. You are advised to review this Privacy Policy periodically for any changes.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Contact Us</h2>
          <p>If you have questions or concerns about this Privacy Policy, please contact us at:</p>
          <div className="contact-info">
            <p><strong>SVT Consulting LLC</strong></p>
            <p>Email: info@svtconsulting.co</p>
            <p>Phone: (201) 429-0602</p>
            <p>Website: svtconsulting.co</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Privacy;
